import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { COVERAGE } from 'Global/constants'
import { useWindowDimensions } from 'Components/WindowDimensions'

import SELECTOR from '../../Redux/selectors'

import Info from './Components/info'
import Coverage from './Components/coverage'
import Dropdown from './Components/CoverageDropdown'
import Button from '../../../../Components/Button'

import Tag from 'Components/Tag'

import { TagWrapper, Card, Line, TopContainer, HorizContainer, ButtonContainer, CreationDate } from './style'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

const InfoCard = ({ type, includes, notIncludes, changeType, handleEdit, creationDate }) => {
  const device = useWindowDimensions()

  const highlights = useSelector(SELECTOR.HIGHLIGHTS)
  const product = useSelector(SELECTOR.PRODUCT)

  const formatDate = () => {
    const date = new Date(creationDate)
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()

    return `${day}/${month}/${year}`
  }

  return (
    <Card device={device}>
      <TopContainer device={device}>
        <div>
          <div className='innerTopContainer'>
            <div>
              <div className='titleInfoContainer'>
                <span className='titleInfo'><b>Producto:</b></span>
                {product.name &&
                  <p className='text custom-text'>
                    {product.name}
                  </p>}
              </div>
              {highlights.length > 0 &&
                <div className='titleInfoContainer'>
                  <span className='titleInfo'><b>Cotizando para:</b></span>
                  <p className='text custom-text'>
                    {
                      Array.isArray(highlights)
                        ? highlights.join('. ')
                        : (highlights || '-')
                    }
                  </p>
                </div>}
              {creationDate && (
                <CreationDate>
                  <b>Fecha de creación:</b> {formatDate()}
                </CreationDate>
              )}
            </div>
            <div className='editWrapper'>
              <Button
                size='small'
                color='primary'
                onClick={handleEdit}
              >
                  Editar
              </Button>
            </div>
          </div>
        </div>
        <HorizContainer>
          <Coverage type={type} changeType={changeType} />
          <Info device={device} title='Incluye:' information={includes} />
          <Info device={device} title='No incluye:' information={notIncludes} />
        </HorizContainer>
      </TopContainer>
      <ButtonContainer>
        <Dropdown onClick={changeType} margin='0 30px 0 30px' />
      </ButtonContainer>
    </Card>
  )
}

InfoCard.propTypes = {
  type: PropTypes.oneOf(Object.values(COVERAGE)),
  includes: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string
  ]),
  changeType: PropTypes.func,
  handleEdit: PropTypes.func
}

export default InfoCard
